import React from "react";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Services from "../components/services/Services";

function ServicesPage() {
  return (
    <div>
      <Header />
      <Services />
      <Footer />
    </div>
  );
}

export default ServicesPage;
